
/// <amd-module name="Build/DesignerExtensions/YamlAssistantLibrary/Contracts/Constants" />
export const UnparentedInputsGroupName: string = "unparented";
export const AzureRMConnectionType: string = "azurerm";
export const DataSourcePrefix: string = "datasource:";
export const ConnectedServicePrefix: string = "connectedservice:";
export const YamlAssistantToggleElement = "yaml-assistant-toggle-element";

export namespace TelemetryConstants {
    export const Area = "Build";

    export const Error = "YamlSnippet.Error";
    export const SnippetSelected = "YamlSnippet.Selected";
    export const TabSwitch = "YamlSnippet.TabSwitch";
    export const ExportSnippet = "YamlSnippet.Export";
    export const ExportOutline = "YamlSnippet.ExportOutline";
    export const LoadedUnsupportedSnippet = "YamlSnippet.LoadedUnsupportedSnippet";
    export const createAzureRM = "YamlSnippet.createAzureRM";
    export const FindEndpointByName = "YamlSnippet.findEndpointByName";
}

/**
 * These are the endpoint Ids of internal apis. Task inputs contain json that defines
 * how we should call them and parse their results to display in the UI as options.
 */
export const InternalDataSources: {[key:string]: string} = {
    "tfs:devtestlabs": "tfs:0000000e-0000-8888-8000-000000000000",
    "tfs:teamfoundation": "tfs:00025394-6065-48CA-87D9-7F5672854EF7",
    "tfs:feed": "tfs:00000036-0000-8888-8000-000000000000",
    "tfs:governance": "tfs:00000049-0000-8888-8000-000000000000",
    "tfs:rm": "tfs:0000000D-0000-8888-8000-000000000000",
    "tfs:ems": "tfs:00000028-0000-8888-8000-000000000000"
};